var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("button", { class: _vm.activate(), on: { click: _vm.onClick } }, [
    _c("img", { attrs: { src: _vm.src, alt: _vm.text } })
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }